import React from 'react';
const works = require('./works.json');

const withData = (WrappedComponent) => props => (
  <WrappedComponent {...props} data={works} />
);

export default withData;
